import { useState } from "react";
import toast from "react-hot-toast";
import { useNavigate, useParams } from "react-router";
import { FormatDateTime } from "../../../../../utils/functions/ResourceFunctions";
import { useGetFloatRequestByIdQuery } from "../../../../api/employeeFloat";
import { useApproveFloatRetirementMutation, useGetRetirementByIdQuery, useRejectFloatRetirementMutation } from "../../../../api/financeApi";
import DashboardStyle from "../../../../dashboard/Styles/Dashboard.module.css";
import { ActionButtons, CTAButtonsAlt } from "../../../../global/components/Buttons/buttons";
import PageLayout from "../../../Components/Layout/PageLayout";
import { TableActionsDownload } from "../../../Components/Misc/Actions";
import { AppModalTemplate } from "../../../Components/Modals/Modals";
import Table from "../../../Components/Table/Table";
import { SurveyDeclineModal } from "../../Finance/AdminFeedbackSurvey/Modal/DeclineModal";
import FeedbackApproveModal from "./modals/ApprovalModal";
import { SurveyModal } from "./modals/SurveyModal";
const floatList = [
  {
    label: "Float Advance",
    value: 0,
  },
  {
    label: "Promotional Items",
    value: 1,
  },
  { label: "Perishables", value: 2 },
  {
    label: "Visitation",
    value: 3,
  },
];
const ViewFloatControl = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [openApproveModal, setOpenApproveModal] = useState(false);
  const [openDeclineModal, setOpenDeclineModal] = useState(false);
  const [comment, setComment] = useState("");
  const handleComment = (e) => {
    setComment(e.target.value);
  };
  const handleApproveModal = () => setOpenApproveModal(!openApproveModal);
  const handleDeclineModal = () => setOpenDeclineModal(!openDeclineModal);
  const { data } = useGetFloatRequestByIdQuery(id);
  const { data: retirementData } = useGetRetirementByIdQuery(id);
  const [openSurveyModal, setOpenSurveyModal] = useState();
  const [onApprove, { isLoading: approving }] = useApproveFloatRetirementMutation();
  const [onDecline, { isLoading: declining }] = useRejectFloatRetirementMutation();
  const handleOpenSurveyModal = () => setOpenSurveyModal(!openSurveyModal);
  const handleApprovalSubmit = async () => {
    try {
      const surveyApprovalPayload = {
        id: parseInt(id),
        comment
      };
      const response = await onApprove(surveyApprovalPayload).unwrap();
      if (response?.successful) {
        navigate(-1);
        toast.success(response?.statusMessage);
      }
    } catch (error) {
      toast.error(error?.data?.statusMessage);
      console.error("Error updating survey:", error);
    }
  };
  const handleDeclineSubmit = async () => {
    try {
      const surveyDeclinePayload = {
        id: parseInt(id),
        comment
      };
      const response = await onDecline(surveyDeclinePayload).unwrap();
      if (response?.successful) {
        navigate(-1);
        toast.success(response?.statusMessage);
      }
    } catch (error) {
      toast.error(error?.data?.statusMessage);
      console.error("Error updating survey:", error);
    }
  };
  const actionButton = (
    <div>
      <div className={DashboardStyle.button_cage}>
        <ActionButtons
          width={"auto"}
          className={DashboardStyle?.button_cage_weight}
          style={{ backgroundColor: "red" }}
          onClick={handleDeclineModal}
          type="button"
        >
          Decline
        </ActionButtons>
        <button
          width={"auto"}
          className={`bg-[#305F32]  rounded-md px-5 py-4 text-[#FCFCFC]`}
          onClick={handleApproveModal}
          type="button"
        >
          Approve
        </button>
        <CTAButtonsAlt type="button" hideIcon={true} onClick={handleOpenSurveyModal}>
          View Survey
        </CTAButtonsAlt>
      </div>
    </div>
  );
  const purposes = [
    { label: "Business Development", value: 0 },
    { label: "Relationship Management", value: 1 },
  ];
  const requestForOptions = [
    { label: "Self", value: 0 },
    { label: "Team", value: 1 },
  ];
  const categoryType = data?.responseObject?.purpose === 0 ? 1 : 2;
  return (
    <PageLayout
      title={"Float Review Details"}
      hasBack={true}
      action={actionButton}
    >
      <div className={DashboardStyle.view_app_components}>
        <section
          style={{
            backgroundColor: "#F8FBF8",
            border: "1px solid #D9E9DA",
            borderRadius: "8px",
          }}
          className={DashboardStyle.form_section}
        >
          <h4 className={DashboardStyle.form_section_title}>
            Process Information
          </h4>
          <div className={DashboardStyle.labels_group}>
            <div>
              <div>
                <p>Process Type:</p>
                <h4>Float Retirement</h4>
              </div>
              <div>
                <p>Date Requested:</p>
                <h4>{FormatDateTime(data?.responseObject?.requestDate)}</h4>
              </div>
              <div>
                <p>Approval Status:</p>
                <h4>{data?.responseObject?.approvalResponse?.status}</h4>
              </div>
            </div>
            <div>
              <div>
                <p>Requested By:</p>
                <h4>{data?.responseObject?.requestorName}</h4>
              </div>
            </div>
          </div>
        </section>
        <section
          style={{
            backgroundColor: "#F8FBF8",
            border: "1px solid #D9E9DA",
            borderRadius: "8px",
          }}
          className={DashboardStyle.form_section}
        >
          <h4 className={DashboardStyle.form_section_title}>
            Request Information
          </h4>

          <div className={DashboardStyle.labels_group}>
            <div>
              <div>
                <p>Purpose:</p>
                <h4>{purposes.filter((item) => item.value === data?.responseObject?.purpose)[0]?.label}</h4>
              </div>
              <div>
                <p>Reqest For:</p>
                <h4>{requestForOptions.filter((item) => item.value === data?.responseObject?.requestFor)[0]?.label}</h4>
              </div>
            </div>
            <div>
              <div>
                <p>Effective Days:</p>
                {/* <h4>{request?.employeeGroup?.title}</h4> */}
              </div>
              <div>
                <p>Number Of Days:</p>
                {/* <h4>{FormatDateTime(employeecreatedDate, "ll")}</h4> */}
              </div>
              <div></div>
            </div>
          </div>
        </section>
        <section
          style={{
            backgroundColor: "#F8FBF8",
            border: "1px solid #D9E9DA",
            borderRadius: "8px",
          }}
          className={DashboardStyle.form_section}
        >
          <h4 className={DashboardStyle.form_section_title}>
            Float Information
          </h4>

          <div className={DashboardStyle.labels_group}>
            <div>
              <div>
                <p>Float Type:</p>
                <h4>
                  {floatList
                    .filter((item) =>
                      data?.responseObject?.floatTypes?.includes(item.value),
                    )
                    .map((item) => `${item.label},`)}
                </h4>
              </div>
            </div>
          </div>
        </section>
        <section
          className="p-4 grid grid-cols-2 gap-4"
        >
          <div className="col-span-1">
            <h4 className={DashboardStyle.form_section_title}>Float Advance</h4>
          </div>

          <div className="w-full col-span-2">
            <div className={DashboardStyle.labels_group}>
              <div>
                <div>
                  <p>Sub-Category:</p>
                  <h4>{data?.responseObject?.floatAdvance?.subcategory}</h4>
                </div>
                <div>
                  <p>Total Amount:</p>
                  <h4>{data?.responseObject?.floatAdvance?.totalAmount}</h4>
                </div>
              </div>
              <div>
                <div>
                  <p>Budget:</p>
                  {/* <h4>{request?.employeeGroup?.title}</h4> */}
                </div>
                <div>
                  <p>Budget Status:</p>
                  {/* <h4>{FormatDateTime(employeecreatedDate, "ll")}</h4> */}
                </div>
              </div>
            </div>
            {data?.responseObject?.floatAdvance?.components?.length > 0 && 
            <div className="mb-4">
              <label className="block text-sm font-medium mb-2">
                Components
              </label>
              <table className="w-full border">
                <thead className="text-[#29382A] font-[500] bg-[#D9E9DA]">
                  <tr>
                    <th className="border p-2">S/N</th>
                    <th className="border p-2">Component</th>
                    <th className="border p-2">Optional</th>
                    <th className="border p-2">Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.responseObject?.floatAdvance?.components?.map(
                    (item, index) => {
                      return (
                        <tr className="text-[#4B664C] font-[500]" key={index}>
                          <td className="border p-2">{index + 1}</td>
                          <td className="border p-2">{item.componentName}</td>
                          <td className="border p-2">
                            {item.isCompulsory ? "Yes" : "No"}
                          </td>
                          <td className="border p-2">
                            <div className="border rounded flex items-center space-x-1 p-1 ">
                              <p>₦{item.amount}</p>
                            </div>
                          </td>
                        </tr>
                      );
                    },
                  )}
                </tbody>
              </table>
            </div>}
            <section>
              <div
                className={` ${DashboardStyle.labels_group} ${DashboardStyle.labels_group_downloads} `}
              >
                {retirementData?.result?.documents?.length === 0 ? (
                  <p>No Record Available</p>
                ) : (
                  <Table>
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>File Name</th>
                        <th>File Type</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {retirementData?.result?.documents?.map?.((x, index) => {
                        return (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{x?.fileName || x?.file?.name}</td>
                            <td style={{ textTransform: "uppercase" }}>
                              {x?.file?.type?.split("/")?.[1] ||
                                x?.fileName?.split(".")?.pop()?.toUpperCase() ||
                                "Unknown"}
                            </td>
                            <td>
                              <TableActionsDownload
                                file={x?.file || null}
                                url={x?.fileUrl || null}
                              />
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                )}
              </div>
            </section>
          </div>
        </section>
        {data?.responseObject?.promotionalItems?.items?.length > 0 &&
          <section
            className="p-4 grid grid-cols-2 gap-4"
          >
            <div className="col-span-1">
              <h4 className={DashboardStyle.form_section_title}>
                Promotional Item
              </h4>
            </div>

            <div className="w-full col-span-2">
              <div className={DashboardStyle.labels_group}>
                <div>
                  <div>
                    <p>Item Category:</p>
                    <h4>
                      {data?.responseObject?.promotionalItems?.itemCategory}
                    </h4>
                  </div>
                  <div>
                    <p>Budget:</p>
                    <h4>{data?.responseObject?.floatAdvance?.totalAmount}</h4>
                  </div>
                </div>
                <div>
                  <div>
                    <p>Budget Status:</p>
                    {/* <h4>{FormatDateTime(employeecreatedDate, "ll")}</h4> */}
                  </div>
                </div>
              </div>
              <div>
                <table className="w-full border">
                  <thead className="text-[#29382A] font-[500] bg-[#D9E9DA]">
                    <tr>
                      <th className="border p-2">S/N</th>
                      <th className="border p-2">Items</th>
                      <th className="border p-2">Stock Availability</th>
                      <th className="border p-2">Quantity Requested</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.responseObject?.promotionalItems?.items?.map(
                      (item, index) => {
                        return (
                          <tr className="text-[#4B664C] font-[500]" key={index}>
                            <td className="border p-2">{index + 1}</td>
                            <td className="border p-2">{item.itemName}</td>
                            <td className="border p-2">{item.availableStock}</td>
                            <td className="border p-2">{item.quantity}</td>
                          </tr>
                        );
                      },
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </section>}
      </div>
      {
        openSurveyModal && <AppModalTemplate
          width={"700px"}
          isOpen={openSurveyModal}
          setIsOpen={handleOpenSurveyModal}
        >
          <SurveyModal
            setOpenSurveyModal={setOpenSurveyModal}
            CategoryType={categoryType}
          />
        </AppModalTemplate>
      }
      <FeedbackApproveModal
        isOpen={openApproveModal}
        handleClose={handleApproveModal}
        handleDelete={handleApprovalSubmit}
        handleComment={handleComment}
        isLoading={approving}
        hasComment
        headText={"Approve Feedback Survey"}
      />
      <SurveyDeclineModal
        openModal={openDeclineModal}
        closeModal={handleDeclineModal}
        handleComment={handleComment}
        handleDelete={handleDeclineSubmit}
        isLoading={declining}
      />
    </PageLayout>
  )
}

export { ViewFloatControl };
